module.exports = __webpack_public_path__ + "img/img-01.2a7e171a.jpg";